import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { isEmptyObject } from '../../../../core/util/object';
import ServicesList from './ServicesList';

class Services extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { expanded: false };
  }

  shouldRender = () => {
    const {
      location: { servicesObj },
    } = this.props;
    return !isEmptyObject(servicesObj);
  };

  render = () => {
    if (!this.shouldRender()) return null;
    return <ServicesList {...this.props} />;
  };
}

Services.propTypes = {
  location: PropTypes.object.isRequired,
  enableCollapsing: PropTypes.bool,
  defaultExpanded: PropTypes.bool,
  isReadOnly: PropTypes.bool,
};

export default Services;
